import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import { SITE } from "@/data/site";

const Block = ({ title, children }) => (
  <div className="border-t border-white/10 py-8">
    <h2 className="mb-3 font-heading text-2xl font-bold uppercase text-white">{title}</h2>
    <div className="space-y-3 font-body text-sm leading-relaxed text-neutral-400">{children}</div>
  </div>
);

export default function Datenschutz() {
  return (
    <Layout>
      <Seo title="Datenschutz | KeyMaster KFZ Cloppenburg" description="Datenschutzerklärung von KeyMaster KFZ, Cloppenburg – Informationen zur Verarbeitung personenbezogener Daten." path="/datenschutz" />
      <section className="bg-[#050505] pt-32 pb-24 sm:pt-40">
        <div className="mx-auto max-w-[900px] px-5 sm:px-8">
          <h1 className="font-heading text-5xl font-black uppercase tracking-tight text-white sm:text-6xl">Datenschutz</h1>
          <p className="mt-4 font-body text-neutral-400">Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO.</p>

          <div className="mt-8">
            <Block title="Verantwortlicher">
              <p>{SITE.owner}<br />{SITE.address.street}, {SITE.address.zip} {SITE.address.city}<br />
              Telefon: {SITE.phoneDisplay}<br />E-Mail: {SITE.email}</p>
            </Block>
            <Block title="Erhebung und Verarbeitung">
              <p>Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung der Nutzer oder auf gesetzlicher Grundlage (Art. 6 DSGVO).</p>
            </Block>
            <Block title="Kontaktformular">
              <p>Wenn du uns über das Kontaktformular Anfragen zukommen lässt, werden deine Angaben inklusive der von dir angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne deine Einwilligung weiter. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b und f DSGVO.</p>
            </Block>
            <Block title="Cookies & Einwilligung">
              <p>Diese Website verwendet technisch notwendige Cookies, die für den Betrieb erforderlich sind. Optionale Cookies (z. B. Statistik oder Marketing) werden nur mit deiner ausdrücklichen Einwilligung über unser Cookie-Banner gesetzt. Deine Einwilligung kannst du jederzeit über den Link „Cookie-Einstellungen" im Seitenfuß anpassen oder widerrufen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO bzw. § 25 TDDDG.</p>
            </Block>
            <Block title="Deine Rechte">
              <p>Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch. Zudem steht dir ein Beschwerderecht bei einer Aufsichtsbehörde zu.</p>
            </Block>
            <Block title="Speicherdauer">
              <p>Personenbezogene Daten werden gelöscht, sobald der Zweck der Speicherung entfällt und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</p>
            </Block>
            <Block title="Hosting & Server-Logfiles">
              <p>Beim Besuch der Website werden automatisch technische Zugriffsdaten (z. B. IP-Adresse, Datum/Uhrzeit, Browsertyp) verarbeitet, um einen sicheren und stabilen Betrieb zu gewährleisten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.</p>
            </Block>
          </div>
        </div>
      </section>
    </Layout>
  );
}
